__turbopack_context__.v({
  "content": "styles-module-scss-module__-uH4TG__content",
  "information": "styles-module-scss-module__-uH4TG__information",
  "paragraph": "styles-module-scss-module__-uH4TG__paragraph",
});
